import { render, staticRenderFns } from "./VerticalDivider.vue?vue&type=template&id=674add76&scoped=true&"
import script from "./VerticalDivider.vue?vue&type=script&lang=js&"
export * from "./VerticalDivider.vue?vue&type=script&lang=js&"
import style0 from "./VerticalDivider.vue?vue&type=style&index=0&id=674add76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674add76",
  null
  
)

export default component.exports